import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import i18next from 'i18next';
import { getStateBySlug } from '../../config/states';
import './StateParty.css';

const FALLBACK_NAMES = {
  johor: '柔佛',
  kedah: '吉打',
  penang: '槟城',
  kelantan: '吉兰丹',
  melaka: '马六甲',
  negerisembilan: '森美兰',
  selangor: '雪兰莪',
  sabah: '沙巴',
  terengganu: '登嘉楼',
  sarawak: '砂拉越',
  perlis: '玻璃市',
  perak: '霹雳',
  pahang: '彭亨',
  kl: '联邦直辖区',
};

const stateLabel = (slug) => {
  const cfg = getStateBySlug(slug);
  if (cfg) return i18next.t(cfg.nameKey);
  return i18next.t(FALLBACK_NAMES[slug]) || slug;
};

const StateParty = () => {
  const [dataN, setNData] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get('public-api/negeri')
      .then((res) => {
        if (!cancelled) setNData(res.data || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const totals = dataN.reduce(
    (acc, row) => {
      acc.bn += row.bn || 0;
      acc.ph += row.ph || 0;
      acc.pn += row.pn || 0;
      acc.other += row.other || 0;
      return acc;
    },
    { bn: 0, ph: 0, pn: 0, other: 0 },
  );

  return (
    <div className="state-party-wrap">
      <table className="state-party-table">
        <thead>
          <tr>
            <th>{i18next.t('州议席')}</th>
            <th>{i18next.t('国阵')}</th>
            <th>{i18next.t('希盟')}</th>
            <th>{i18next.t('国盟')}</th>
            <th>其他</th>
          </tr>
        </thead>
        <tbody>
          {dataN.map((row) => {
            const slug = (row.country || '').toLowerCase();
            return (
              <tr key={slug}>
                <td className="state-party-table__name">
                  <Link to={`${slug}/n`}>
                    {row.icon && <img src={row.icon} alt="" />}
                    <span>{stateLabel(slug)}</span>
                  </Link>
                </td>
                <td>{row.bn}</td>
                <td>{row.ph}</td>
                <td>{row.pn}</td>
                <td>{row.other}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="state-party-table__total">
            <td>{i18next.t('总计')}</td>
            <td>{totals.bn}</td>
            <td>{totals.ph}</td>
            <td>{totals.pn}</td>
            <td>{totals.other}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default StateParty;
